module.exports = __webpack_public_path__ + "img/kushenta-2.9286f08b.jpg";